/**
 * Cart Print Functionality
 * Generates a printable PDF version of the shopping cart
 */

function printCartDrawer() {
    // Fetch current cart data from Shopify
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Create print window
        const printWindow = window.open('', '_blank', 'width=800,height=600');
        
        // Get shop information (these will be replaced by Liquid in the main file)
        const logoUrl = window.SHOP_LOGO_URL || '';
        const shopName = window.SHOP_NAME || 'Shop';
        const shopUrl = window.SHOP_URL || '';
        
        // Generate PDF-friendly HTML
        const printContent = generatePrintHTML(cart, logoUrl, shopName, shopUrl);
        
        printWindow.document.write(printContent);
        printWindow.document.close();
      })
      .catch(error => {
        console.error('Cart print error:', error);
        alert('Sepet yazdırılırken bir hata oluştu. Lütfen tekrar deneyin.');
      });
  }
  
  function generatePrintHTML(cart, logoUrl, shopName, shopUrl) {
    // Prices are KDV-inclusive: split the existing total, don't add on top.
    // Net is floored to a whole lira so the rows always sum exactly (same as the cart display).
    const kdvNet = Math.floor(Math.floor(cart.total_price / 1.2) / 100) * 100;
    const kdvAmount = cart.total_price - kdvNet;
    return `
      <!DOCTYPE html>
      <html lang="tr">
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Sepet - ${shopName}</title>
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
            padding: 40px;
            color: #333;
            background: #fff;
          }
          
          .header {
            text-align: center;
            margin-bottom: 40px;
            padding-bottom: 20px;
            border-bottom: 3px solid #000;
          }
          
          .header-logo {
            margin-bottom: 20px;
          }
          
          .header-logo img {
            max-width: 120px;
            max-height: 50px;
            width: auto;
            height: auto;
          }
          
          .header h1 {
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 8px;
            text-transform: uppercase;
          }
          
          .header p {
            color: #666;
            font-size: 14px;
          }
          
          .cart-info {
            margin-bottom: 30px;
            padding: 15px;
            background: #f5f5f5;
            border-radius: 8px;
          }
          
          .cart-info p {
            font-size: 14px;
            margin: 5px 0;
          }
          
          .cart-items {
            margin-bottom: 40px;
          }
          
          .cart-item {
            display: flex;
            gap: 20px;
            padding: 25px 0;
            border-bottom: 1px solid #e0e0e0;
          }
          
          .cart-item:first-child {
            padding-top: 0;
          }
          
          .item-image {
            flex-shrink: 0;
          }
          
          .item-image img {
            width: 120px;
            height: 120px;
            object-fit: cover;
            border: 1px solid #ddd;
            border-radius: 4px;
          }
          
          .item-details {
            flex: 1;
          }
          
          .item-title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 8px;
            text-transform: uppercase;
            color: #000;
          }
          
          .item-sku {
            font-size: 13px;
            color: #666;
            margin-bottom: 6px;
          }
          
          .item-variant {
            font-size: 13px;
            color: #666;
            margin-bottom: 4px;
          }
          
          .item-quantity {
            font-size: 14px;
            color: #333;
            margin-top: 8px;
            font-weight: 500;
          }
          
          .item-price {
            text-align: right;
            flex-shrink: 0;
          }
          
          .item-price-value {
            font-size: 22px;
            font-weight: 700;
            color: #000;
          }
          
          .item-price-original {
            font-size: 14px;
            color: #999;
            text-decoration: line-through;
            margin-top: 4px;
          }
          
          .cart-summary {
            margin-top: 40px;
            padding-top: 30px;
            border-top: 3px solid #000;
          }
          
          .summary-row {
            display: flex;
            justify-content: space-between;
            padding: 12px 0;
            font-size: 16px;
          }
          
          .summary-row.discount {
            color: #d32f2f;
          }
          
          .summary-row.total {
            font-weight: 700;
            font-size: 28px;
            margin-top: 15px;
            padding-top: 15px;
            border-top: 2px solid #e0e0e0;
          }
          
          .footer-note {
            margin-top: 30px;
            padding: 20px;
            background: #f9f9f9;
            border-radius: 8px;
            font-size: 13px;
            color: #666;
            text-align: center;
          }
          
          @media print {
            body {
              padding: 20px;
            }
            
            .header {
              margin-bottom: 30px;
            }
            
            @page {
              margin: 1cm;
            }
          }
        </style>
      </head>
      <body>
        <div class="header">
          ${logoUrl ? `
            <div class="header-logo">
              <img src="${logoUrl}" alt="${shopName}">
            </div>
          ` : `
            <h1>${shopName}</h1>
          `}
          <p>Sepet Özeti - ${new Date().toLocaleDateString('tr-TR', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })}</p>
        </div>
        
        <div class="cart-info">
          <p><strong>Ürün Sayısı:</strong> ${cart.item_count}</p>
          <p><strong>Toplam Ürün:</strong> ${cart.items.length}</p>
        </div>
        
        <div class="cart-items">
          ${cart.items.map(item => {
            const hasDiscount = item.original_line_price > item.final_line_price;
            
            return `
              <div class="cart-item">
                <div class="item-image">
                  <img src="${item.image}" alt="${item.title}">
                </div>
                
                <div class="item-details">
                  <div class="item-title">${item.product_title}</div>
                  
                  ${item.sku ? `<div class="item-sku">SKU: ${item.sku}</div>` : ''}
                  
                  ${item.variant_title && item.variant_title !== 'Default Title' ? 
                    `<div class="item-variant">${item.variant_title}</div>` : ''}
                  
                  <div class="item-quantity">Adet: ${item.quantity}</div>
                </div>
                
                <div class="item-price">
                  <div class="item-price-value">
                    ${formatMoney(item.final_line_price)}
                  </div>
                  ${hasDiscount ? `
                    <div class="item-price-original">
                      ${formatMoney(item.original_line_price)}
                    </div>
                  ` : ''}
                </div>
              </div>
            `;
          }).join('')}
        </div>
        
        <div class="cart-summary">
          ${cart.total_discount > 0 ? `
            <div class="summary-row discount">
              <span>İndirim:</span>
              <span>-${formatMoney(cart.total_discount)}</span>
            </div>
          ` : ''}
          
          <div class="summary-row">
            <span>Ara Toplam (KDV Hariç):</span>
            <span>${formatMoney(kdvNet)}</span>
          </div>
          
          <div class="summary-row">
            <span>KDV (%20):</span>
            <span>${formatMoney(kdvAmount)}</span>
          </div>

          <div class="summary-row total">
            <span>TOPLAM:</span>
            <span>${formatMoney(cart.total_price)}</span>
          </div>
        </div>
        
        <div class="footer-note">
          <p>Kargo ücreti ödeme sayfasında hesaplanacaktır.</p>
          <p style="margin-top: 8px; font-size: 12px;">${shopUrl}</p>
        </div>
        
        <script>
          function formatMoney(cents) {
            const amount = (cents / 100).toFixed(2);
            return '₺ ' + amount.replace(/\\B(?=(\\d{3})+(?!\\d))/g, '.');
          }
          
          // Auto-trigger print dialog
          window.onload = function() {
            setTimeout(function() {
              window.print();
            }, 500);
          };
          
          // Close window after printing or canceling
          window.onafterprint = function() {
            setTimeout(function() {
              window.close();
            }, 100);
          };
        <\/script>
      </body>
      </html>
    `;
  }
  
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '₺ ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }